interface Benefit {
  icon: React.ReactNode;
  text: string;
}

interface inpartBenefitsDesktopProps {
  benefits: Benefit[];
}

function InpartBenefitsDesktop({ benefits }: inpartBenefitsDesktopProps) {
  return (
    <aside className="bg-content-primary text-content-inverted rounded-lg p-4 sm:p-6 flex flex-col gap-6 w-full">
      <h2 className="text-body-xl font-headline-h2 m-0 leading-headline-h2 text-content-inverted">Why Join Inpart?</h2>
      <div className="flex flex-col gap-6">
        {benefits.map((b, idx) => (
          <div key={idx} className="text-left">
            <div className="flex items-start gap-2">
              {b.icon}
              <span className="text-body-lg leading-5">{b.text}</span>
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
}

export default InpartBenefitsDesktop;
